module.exports = __webpack_public_path__ + "img/黑桃中级大师@3x.8927ef9e.png";